"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var FAQ = /** @class */ (function (_super) {
    __extends(FAQ, _super);
    function FAQ(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            faqs: _this.props.section.blocks
        };
        _this.buildFaq = _this.buildFaq.bind(_this);
        return _this;
    }
    FAQ.prototype.render = function () {
        var _this = this;
        var _a = this.props.section, settings = _a.settings, blocks = _a.blocks;
        return (React.createElement("section", { className: "py-12 text-left border-b border-grey" },
            React.createElement("div", { className: (!settings.full_width ? "container mx-auto" : "") + " flex flex-wrap" },
                React.createElement("div", { className: "w-full mb-3" },
                    React.createElement("h1", { className: "" }, settings.title),
                    React.createElement("span", { className: "subtitle" }, settings.subtitle),
                    React.createElement("div", { dangerouslySetInnerHTML: { __html: "" + settings.content } }),
                    settings.link_text ? (React.createElement("a", { href: settings.link_url, title: settings.link_text }, settings.link_text)) : null),
                React.createElement("br", null),
                React.createElement("div", { className: "w-full mt-3" }, blocks ? blocks.map(function (block, i) { return _this.buildFaq(block.settings, i); }) : []))));
    };
    FAQ.prototype.buildFaq = function (settings, key) {
        return React.createElement(AccordionItem, { key: key, keyI: key, faq: settings });
    };
    FAQ.sectionId = "faq";
    return FAQ;
}(React.PureComponent));
exports.FAQ = FAQ;
var AccordionItem = /** @class */ (function (_super) {
    __extends(AccordionItem, _super);
    function AccordionItem(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            open: false
        };
        return _this;
    }
    AccordionItem.prototype.toggle = function () {
        this.setState({
            open: !this.state.open
        });
    };
    AccordionItem.prototype.render = function () {
        var _this = this;
        var activeClass = this.state.open ? "block" : "hidden";
        var faq = this.props.faq;
        var i = this.props.keyI;
        return (React.createElement("div", { key: i, className: "w-full mb-3" },
            React.createElement("strong", { onClick: function (event) {
                    _this.toggle();
                }, dangerouslySetInnerHTML: { __html: "" + faq.question } }),
            React.createElement("div", { className: activeClass },
                React.createElement("span", { dangerouslySetInnerHTML: { __html: "" + faq.answer } }))));
    };
    return AccordionItem;
}(React.Component));
exports.AccordionItem = AccordionItem;
